import React from 'react';
import { Layout, Row } from 'antd';
import usePageContainerMinHeight from 'utils/CustomHooks/usePageContainerMinHeight';
import LoadingIcon from 'assets/icn-suspense-loading.svg';
import './styles.scss';

const { Content } = Layout;

const SuspenseLoading = () => {
  const pageContainerMinHeight = usePageContainerMinHeight();

  return (
    <Layout className="pps-SuspenseLoading">
      <Content>
        <Row
          justify="center"
          align="middle"
          style={{ minHeight: pageContainerMinHeight }}
        >
          <div className="pps-SuspenseLoading__wrapper">
            <img src={LoadingIcon} alt="" />
          </div>
        </Row>
      </Content>
    </Layout>
  );
};

export default SuspenseLoading;
